<div
  class="visual-builder-block"
  [class.mr-2]="!isMobile"
  [class.mobile-language-select]="isMobile"
  [class.selected]="selectedId?.id === 'languageMenu'"
  (click)="selectBlock.emit('languageMenu')"
  [ngStyle]="{ '--lang-menu-color': languageMenu.font?.fontColor || '#000000' }"
>
  <p-dropdown
    [options]="languages"
    (onChange)="selectLanguage()"
    [(ngModel)]="selectedLanguage"
    optionValue="code"
    optionLabel="name"
    [filter]="true"
    filterBy="name"
    [showClear]="false"
    placeholder="Select a Language"
  >
    <ng-template pTemplate="selectedItem">
      <div class="flex align-items-center gap-2" *ngIf="selectedLanguage">
        <div [ngStyle]="languageMenu | fontFamily">
          {{ selectedLanguageTitle }}
        </div>
      </div>
    </ng-template>
    <ng-template let-language pTemplate="item">
      <div class="flex align-items-center gap-2">
        <div
          [ngStyle]="languageMenu | fontFamily | assign : { color: '#000000' }"
        >
          {{ language.name }}
        </div>
      </div>
    </ng-template>
  </p-dropdown>
</div>
